import { FC } from 'react';

import { Typography } from 'antd';
import { IDataPoint, TMetric } from 'common/types/dasboard';
import { cents2dollars } from 'common/utils';
import { ECharts } from 'components/ECharts';

import styles from './charts.module.scss';

interface IChartsProps {
  items: IDataPoint[];
  metric: TMetric;
}

export const Charts: FC<IChartsProps> = ({ items, metric }) => {
  if (items.length === 0) {
    return (
      <div className={styles.no_data}>
        <Typography.Text strong>No data for Chart</Typography.Text>
        <Typography.Text>
          Please change time range, metrics or interval
        </Typography.Text>
      </div>
    );
  }

  return (
    <ECharts
      option={{
        xAxis: {
          type: 'category',
          data: items.map((it) => it.period),
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: (value) =>
              metric === 'ORDERS' ? `${value}` : `$ ${cents2dollars(value)}`,
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: (params) => {
            if (!Array.isArray(params)) {
              const valueToRender =
                metric === 'ORDERS'
                  ? `${params.value}`
                  : `$ ${cents2dollars(Number(params.value))}`;
              return `${params.name}: $${cents2dollars(Number(params.value))}`;
            }

            const labels: string[] = [];

            for (const param of params.values()) {
              const valueToRender =
                metric === 'ORDERS'
                  ? `${param.value}`
                  : `$ ${cents2dollars(Number(param.value))}`;
              labels.push(
                `${param.marker} ${param.name}: ${valueToRender}<br/>`,
              );
            }

            return labels.join();
          },
          backgroundColor: 'rgba(50, 50, 50, 0.8)',
          borderColor: '#333',
          textStyle: {
            color: '#fff',
            fontSize: 12,
          },
          padding: 10,
          extraCssText: 'border-radius: 4px;',
        },
        grid: [{ left: '5%', top: '15%', width: '95%', height: '500px' }],
        series: [
          {
            data: items.map((it) => it.value),
            type: 'line',
          },
        ],
      }}
    />
  );
};
